module.exports = __webpack_public_path__ + "static/img/DSC02420.60ecbd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC02420.jpg
// module id = cpS0
// module chunks = 0